import { Search, MessageCircle, MapPin } from "lucide-react";

const steps = [
  {
    icon: Search,
    n: "01",
    title: "Browse curated travel options",
    copy: "Explore resort stays, cruises, group trips, and seasonal travel ideas.",
  },
  {
    icon: MessageCircle,
    n: "02",
    title: "Share your travel interest",
    copy: "Tell us your preferred dates, destination, group size, and travel style.",
  },
  {
    icon: MapPin,
    n: "03",
    title: "Receive next steps",
    copy: "We review availability and guide you through the next steps with care and simplicity.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-20 md:py-32 bg-sand">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <p className="uppercase text-sm tracking-[0.2em] font-semibold text-terracotta mb-4">
            Simple by design
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-ink">
            How KIS Living Vacations Works
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {steps.map(({ icon: Icon, n, title, copy }) => (
            <div key={n} data-testid={`how-step-${n}`} className="relative">
              <div className="flex items-center gap-4 mb-5">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#EAE4DA] text-terracotta">
                  <Icon size={24} strokeWidth={1.5} />
                </span>
                <span className="font-serif text-5xl text-ink/15 font-semibold">{n}</span>
              </div>
              <h3 className="font-serif text-2xl font-semibold text-ink mb-3">{title}</h3>
              <p className="text-base leading-relaxed text-ink-soft">{copy}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
